module.exports = __webpack_public_path__ + "static/media/anc1kz.1ff6c521.pdf";